import type { QueryClient } from '@tanstack/react-query';

/**
 * Liczniki „do zrobienia” (menu, pulpit, dzwonek, Moje sprawy, serwis). Odświeżane po każdej zmianie zapisanej
 * w aplikacji i po sygnale na żywo z serwera — znikają od razu po wykonaniu zadania, bez ponownego wejścia w listę.
 */
const COUNTER_KEYS: readonly (readonly string[])[] = [
  ['notifications'],
  ['process-inbox'],
  ['process-inbox-count'],
  ['service-counters'],
  ['owner-board'],
  ['cases'], // lista spraw z licznikami statusów i „Moje sprawy” na pulpicie
  ['planning-queue'],
  ['invoicing-overview'],
  ['party-correspondence'], // korespondencja z klientem (docs/20) — nowa wiadomość od klienta
];

export function refreshCounters(qc: QueryClient) {
  for (const queryKey of COUNTER_KEYS) void qc.invalidateQueries({ queryKey });
}
